import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    padding: $theme.sizing.scale700,
    display: 'flex',
    flexDirection: 'column'
}))
